

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETSUBDEPARTMENTSBYDEPARTMENTID= createAsyncThunk(
  "getSubDepartmentsByDepartmentId/getSubDepartmentsByDepartmentId",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getSubDepartmentsByDepartmentIdSlice = createSlice({
  name: "getSubDepartmentsByDepartmentIdSlice",
  initialState: {
    getSubDepartmentsByDepartmentId: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetSubDepartmentsByDepartmentId: (state) => {
        state.getSubDepartmentsByDepartmentId.loading = false
        state.getSubDepartmentsByDepartmentId.error = false
        state.getSubDepartmentsByDepartmentId.data = []
        state.getSubDepartmentsByDepartmentId.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETSUBDEPARTMENTSBYDEPARTMENTID.fulfilled, (state, action) => {
      state.getSubDepartmentsByDepartmentId = {
        ...state.getSubDepartmentsByDepartmentId,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETSUBDEPARTMENTSBYDEPARTMENTID.pending, (state, action) => {
      state.getSubDepartmentsByDepartmentId = {
        ...state.getSubDepartmentsByDepartmentId,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETSUBDEPARTMENTSBYDEPARTMENTID.rejected, (state, action) => {
      state.getSubDepartmentsByDepartmentId = {
        ...state.getSubDepartmentsByDepartmentId,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getSubDepartmentsByDepartmentIdAction = {
    GETSUBDEPARTMENTSBYDEPARTMENTID,
};

export { getSubDepartmentsByDepartmentIdAction };
export default getSubDepartmentsByDepartmentIdSlice.reducer;
export const {setInitialStateOfgetSubDepartmentsByDepartmentId} = getSubDepartmentsByDepartmentIdSlice.actions
